import styled from "styled-components";
import { GamesGridDefaultBox } from "./games-grid.default.box";

export const GamesGridSICisBox = styled(GamesGridDefaultBox)`
    background: ${props => props.theme.colors.backgroundLight};
`;
